import { ButtonAlert } from 'components/ButtonAlert';
import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { ErrorHandlingModal } from 'components/ErrorHandlingModal';
import type { IErrorHandlingRequestState } from 'features/errorHandling/errorHandlingSlice';
import { RequestStatus } from 'features/request/requestSlice';
import { cnMixSpace } from 'uikit';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import type React from 'react';
import { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

interface IButtonDeleteProps {
    deleteData?: IErrorHandlingRequestState;
    deleteStatus: RequestStatus;
    deleteError?: any;
    deleteSetData?: (value: any) => any;
    handleDelete: () => void;
    onSuccess?: () => void;
    textHeader?: string;
    textConfirmation?: string;
    style?: React.CSSProperties;
}

export const ButtonDeleteIds = ({
    deleteData,
    deleteStatus,
    deleteError,
    deleteSetData,
    handleDelete,
    onSuccess,
    textHeader = 'УДАЛЕНИЕ ЗАПИСЕЙ',
    textConfirmation = 'Вы уверены, что хотите удалить записи?',
    style,
}: IButtonDeleteProps) => {
    const dispatch = useDispatch();

    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleDeleteExactly = useCallback(() => {
        setIsSubmitted(true);
        handleDelete();
    }, [handleDelete]);

    const handleDeleteBtn = useCallback(() => {
        setIsConfirmationDialogOpen(true);
    }, []);

    const handleOnClose = useCallback(() => {
        if (deleteSetData) {
            dispatch(deleteSetData?.(undefined));
        }
        setIsConfirmationDialogOpen(false);
    }, [deleteSetData, dispatch]);

    const handleCloseModalError = useCallback(() => {
        setIsSubmitted(false);
        setIsConfirmationDialogOpen(false);
    }, []);

    const handleCreateReport = useCallback(() => {
        ExportCSVReport(deleteData?.validation);
    }, [deleteData?.validation]);

    useEffect(() => {
        if (deleteStatus === RequestStatus.SUCCESS && deleteData?.result) {
            if (deleteSetData) {
                dispatch(deleteSetData?.(undefined));
            }

            onSuccess?.();
        }
    }, [deleteData?.result, deleteSetData, deleteStatus, dispatch, onSuccess]);

    return (
        <>
            <ButtonAlert
                label="Удалить"
                size="xs"
                onClick={handleDeleteBtn}
                className={cnMixSpace({ mL: 's' })}
                loading={deleteStatus === RequestStatus.FETCHING}
                disabled={deleteStatus === RequestStatus.FETCHING}
                style={style}
            />
            <ConfirmationDialog
                textHeader={textHeader}
                textConfirmation={textConfirmation}
                isOpened={isConfirmationDialogOpen}
                onSubmit={handleDeleteExactly}
                onClose={handleOnClose}
                cancelButtonText="Не удалять"
                confirmButtonText="Удалить"
            />
            <ErrorHandlingModal
                titleText="Удаление записи"
                isSubmitted={isSubmitted}
                statusRequest={deleteStatus}
                dataRequest={deleteData}
                errorsRequest={deleteError}
                handleCloseModalError={handleCloseModalError}
                handleCreateReport={handleCreateReport}
            />
        </>
    );
};

ButtonDeleteIds.displayName = 'ButtonDeleteIds';
